controllers.controller('LoginController', [
    '$scope', '$ionicHistory', '$state', '$ionicLoading', 'config', 'constants', 'ErrorService', 'UserService',
    'LoginService', 'LocaleService', 'Validator', 'AccountService', '$injector', 'Utils', 'SocialAuthService', 'Storage',
    function ($scope, $ionicHistory, $state, $ionicLoading, config, Const, ErrorService, UserService,
              LoginService, LocaleService, Validator, AccountService, $injector, Utils, SocialAuthService, Storage) {

        $ionicHistory.nextViewOptions({
            disableAnimate: true
        });

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.navigate = function (state) {
            $state.go(state);
        };

        $scope.loginForm = {
            email: '',
            password: ''
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.signUpURL = Utils.createLinkByLang('externalLinks.signUp', LocaleService.lang, 'externalLinks.signUpDefault');

        $scope.template = Storage.get('template');

        $scope.validator = Validator.getPattern;

        $scope.socialAuthService = SocialAuthService;

        $scope.disableSignUp = Const['disableSignup'];

        $scope.isLoginWithSMSEnabled = Const['isLoginWithSMSEnabled'];

        function login(loginForm) {
            //if we are already logged in mt4 account
            var user = UserService.get();
            if (user && user.isLoggedInMT4) {
                return $state.go('root.app.assets', {cache: false});
            }

            $scope.loadingMessage = LocaleService.translation.logging_in;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            function createLoginRequest() {
                if (loginForm.provider && loginForm.tokenThirdParty) {
                    return LoginService.loginThirdParty(loginForm.email, loginForm.provider, loginForm.tokenThirdParty)
                }

                return LoginService.login(loginForm.email, loginForm.password)
            }

            return createLoginRequest()
                .then(function () {
                    $scope.loadingMessage = LocaleService.translation.starting;
                })
                .then(LoginService.initServices)
                .then(function () {

                    $injector.get('Init').isInitialized = true;
                    $ionicLoading.hide();

                    var state = AccountService.checkTradingAccounts();
                    if (state) return $state.go(state);

                    var user = UserService.get();

                    if (Const['showPersonal']) {
                        //check terms
                        if (!user.tnc && Const['tncPopup']) {
                            return $state.go('tnc');
                        }

                        //check state
                        if (user.registrationState <= Const.userState.personal) {
                            return $state.go('root.app.personalDetails');
                        }
                        //check kyc
                        if (user.complianceStatus !== 'approved' && user.registrationState === Const.userState.questionnaire && Const['kycCheck']) {
                            return $state.go('kycCheck');
                        }

                    }

                    // for Trademarkets show modal with classification info (only for 'Rejected')
                    if (user.classification && user.classification === 'Rejected' && user.liveAccountExists) {
                        var scoringRule = _.find(Const['scoringRules'], {classification: user.classification});
                        if (scoringRule) {
                            return $state.go('questionnaireMessage', {buttons: false});
                        }
                    }

                    $state.go('root.app.assets');
                })
                .catch(function (error) {
                    if (error.data && error.data.response && error.data.response.code === 3035 && Const['enable2FA']) {
                        $ionicLoading.hide();

                        return $state.go('login-otp', {
                            cache: false,
                            loginData: {
                                'email': $scope.loginForm.email,
                                'password': $scope.loginForm.password
                            }
                        });
                    }

                    if (error === Const.loginStatus.failedActiveAccount) {
                        $ionicLoading.hide();
                        //popup
                        $scope.modal.isError = true;
                        $scope.modal.textTitle = LocaleService.translation.messages.mt4AuthFailed;
                        $scope.modal.back = 'root.app.manageaccounts';
                        $scope.modal.state = true;
                        return;
                    }

                    //if we failed in starting any service - do logout sequence
                    LoginService.logout()
                        .then(function () {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                        .catch(function (error) {
                            $ionicLoading.hide();
                            $scope.modal.isError = true;
                            $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]) || LocaleService.translation.messages.Err600;
                            $scope.modal.state = true;
                        })
                })
        }


        $scope.login = function (form) {
            Utils.formRevalidate(form);

            if (!form.$valid) return;

            return login(this.loginForm)
        };

        $scope.signinWithGoogle = function () {
            return SocialAuthService.signInWithGoogle()
                .then(function (user) {
                    var loginRequest = {
                        email: user.email,
                        password: "",
                        provider: "google",
                        tokenThirdParty: user.idToken
                    };
                    return login(loginRequest)
                })
        }

        $scope.signinWithFacebook = function () {
            return SocialAuthService.signInWithFacebook()
                .then(function (user) {
                    var loginRequest = {
                        email: user.email,
                        password: "",
                        provider: "facebook",
                        tokenThirdParty: user.token
                    };
                    return login(loginRequest)
                })
        }


    }]);
